import React from "react";

export default function Hero() {
  return (
    <>
      <div className="trigger-showcase position-relative z-1">
        {/* Hero 1 */}
        <section className="hero-1 position-relative overflow-hidden">
          {/* ✅ Video Background */}
          <video
            autoPlay
            loop
            muted
            playsInline
            className="video-bg"
          >
            <source src="assets/img/hero_banner.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          <div className="container">
            <div className="row justify-content-md-center">
              <div className="col-md-10 col-lg-9 col-xxl-10 text-center">
                <h1 className="clr-white fw-extrabold mb-6 animate-line-3d">
                  Own the Future of
                  <br />
                  <span
                    className=""

                  >
                    Blockchain Network
                  </span>

                </h1>
                <p className="fs-18  text-white max-text-50 mx-auto mb-10 animate-text-from-bottom">
                  Powered by Proof-of-Alliance consensus and AI-driven security, Zenochain  empowers building Web3.
                </p>
                <div className="d-inline-block w-100 max-text-60 mx-auto mb-4 position-relative z-1 overflow-hidden rounded fadeIn_bottom">
                  <div className="d-flex p-3 justify-content-around">
                    <a
                      href="/"
                      target="_blank"
                      className="gradient-btn-1 position-relative z-1 link d-inline-flex justify-content-center px-4 py-2 rounded fw-bold text-center"
                    >
                      Get Started
                    </a>
                    <a
                      href="/"
                      target="_blank"
                      className="gradient-btn-1 position-relative z-1 link d-inline-flex justify-content-center px-4 py-2 rounded fw-bold text-center"
                    >
                      Read Whitepaper
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <img
            src="assets/img-1/round_bg.png"
            alt="image"
            style={{ opacity: "0.5" }}
            className="img-fluid hero-1-shapes__img ani-shap hero-1-shapes__img--5"
          />
          <img
            src="assets/img-1/round_bg1.png"
            alt="image"
            className="img-fluid hero-1-shapes__img ani-shap hero-1-shapes__img--6"
          /> */}
        </section>
        {/* /Hero 1 */}

        {/* Breadcrumb / Showcase Section */}
        {/* <div className="breadcrumb-section-inner">
          <div className="container">
            <div className="mt-10">
              <div className="row gy-4">
                <div className="col-sm-6 col-lg-4 col-xxl-4 fadein_bottom_39">
                  <div className="pricing-5-card text-center">
                    <span className="pricing-5-card-name fs-16 fw-bold clr-neutral-90">
                      Utterly Fast
                    </span>
                    <p className="fs-14 clr-neutral-80 mt-3">
                      Capable of processing 5k transactions per second
                    </p>
                    <div className="d-flex align-items-center justify-content-center gap-2">
                      <h3 className="pricing-5-card-price text-black fw-extrabold mb-0 ">
                        5,000+ TP
                      </h3>
                    </div>
                  </div>
                </div>
                <div className="col-sm-6 col-lg-4 col-xxl-4 fadein_bottom_39">
                  <div className="pricing-5-card popular text-center">
                    <span className="pricing-5-card-name fs-16 fw-bold clr-neutral-90">
                      Highly Scalable
                    </span>
                    <p className="fs-14 clr-neutral-80 mt-3">
                      Capacity of onboarding 16,500 Nodes effortlessly
                    </p>
                    <div className="d-flex align-items-center justify-content-center gap-2">
                      <h3 className="pricing-5-card-price fw-extrabold mb-0 clr-neutral-90">
                        16k+ Node Spots
                      </h3>
                    </div>
                  </div>
                </div>
                <div className="col-sm-6 col-lg-4 col-xxl-4 fadein_bottom_39">
                  <div className="pricing-5-card text-center">
                    <span className="pricing-5-card-name fs-16 fw-bold clr-neutral-90">
                      Cost-efficient
                    </span>
                    <p className="fs-14 clr-neutral-80 mt-3">
                      It cost far less-than a cent for sending transactions
                    </p>
                    <div className="d-flex align-items-center justify-content-center gap-2">
                      <h3 className="pricing-5-card-price text-black fw-extrabold mb-0 ">
                        ~$0.0001 Fee
                      </h3>
                    </div>
                  </div>
                </div>
                <div className="section-space-sm-bottom section-space-sm-top">
                  <div className="container">
                    <div className="row justify-content-center">
                      <div className="col-md-8 col-xl-8">
                        <h6 className="mb-0 clr-neutral-90 text-white text-center fw-extrabold animate-line-3d">
                          Discover block data &amp; network insights on
                          <a href="/coming-soon" className="clr-grad-1">
                            {" "}
                            OwnXChain explorer →
                          </a>
                        </h6>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div> */}
      </div>
    </>
  );
}
